import { createReducer, on } from '@ngrx/store';
import * as OutcomeBandwidthActions from '../actions/outcome-bandwidth.actions';

export const outcomeBandwidthFeatureKey = 'outcomeBandwidth';

export interface State {
  record: any;
  error: any;
  loaded: boolean;
  loading: boolean;
}

export const initialState: State = {
  record: null,
  error: null,
  loaded: false,
  loading: false,
};

export const reducer = createReducer(
  initialState,

  on(OutcomeBandwidthActions.loadOutcomeBandwidth, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: true,
  })),
  on(OutcomeBandwidthActions.loadOutcomeBandwidthSuccess, (state, action) => ({
    record: action.data.data,
    error: null,
    loaded: true,
    loading: false,
  })),
  on(OutcomeBandwidthActions.loadOutcomeBandwidthFailure, (state, action) => ({
    record: null,
    error: action.error,
    loaded: false,
    loading: false,
  })),
  on(OutcomeBandwidthActions.clearOutcomeBandwidthState, () => ({
    record: null,
    error: null,
    loaded: false,
    loading: false,
  })),
);
